
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { cn } from '@/common-utils/libraries/tailwind/utils';
import PropTypes from 'prop-types';
import { useToast } from '@/common-utils/hooks/use-toast';
import actionsSubscriptions from '../../api/actionsSubscriptions';
import { DateTime } from 'luxon';
import { nsSubscription } from '@/app/i18n/namespaces';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalMigrateSubscription Component
 */
function ModalMigrateSubscription({ trigger, isOpen, setIsOpen, subscriptionId, subcriptionStartBillingDate, setLaunchRefetch }) {

    // Toast
    const { toast } = useToast();

    // API Calls
    const onSuccess = () => {
        setLaunchRefetch(true);
        toast({
            description: <Entity entity={'modal.migrate.success'} namespace={nsSubscription} />,
            variant: 'success'
        });
        setIsOpen(false);
    };
    const onError = () => {
        toast({
            description: <Entity entity={'modal.migrate.error'} namespace={nsSubscription} />,
            variant: 'danger'
        });
        setIsOpen(false);
    };
    const submitMigrateSubscription = actionsSubscriptions.migrateSubscription(onSuccess, onError);

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.migrate.title'} namespace={nsSubscription} />
            <ModalBody>
                <div className={'mb-4'}><Entity entity={'modal.migrate.text'} namespace={nsSubscription} /></div>
                <div className={'mb-4'}><Entity entity={'modal.migrate.info'} namespace={nsSubscription} /></div>
                <div className={'mb-4 text-lg text-center font-bold'}>
                    {
                        DateTime.fromISO(subcriptionStartBillingDate).startOf('month').plus({ month: 3 }).toLocaleString(DateTime.DATE_HUGE)
                    }
                </div>
                <Entity entity={'modal.migrate.confirm'} namespace={nsSubscription} />
            </ModalBody>
            <FooterForm
                onSubmit={() => submitMigrateSubscription.mutate({ subscriptionId })}
                isSubmitting={submitMigrateSubscription.isLoading}
                isSubmitDisabled={submitMigrateSubscription.isLoading}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            {content}
        </Modal>
    );
}

ModalMigrateSubscription.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string,
    subcriptionStartBillingDate: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalMigrateSubscription;